import type { TaskView } from "../api/generated";

export interface TagCount {
  tag: string;
  count: number;
}

/** Tags used by the given tasks with how many tasks use each, in alphabetical order. */
export function tagCounts(views: readonly TaskView[]): TagCount[] {
  const counts = new Map<string, number>();
  for (const { task } of views) {
    for (const tag of task.tags) counts.set(tag, (counts.get(tag) ?? 0) + 1);
  }
  return [...counts]
    .map(([tag, count]) => ({ tag, count }))
    .sort((left, right) => left.tag.localeCompare(right.tag, undefined, { sensitivity: "base" }));
}

export function inboxCount(views: readonly TaskView[]): number {
  return views.filter(({ task }) => task.project.length === 0).length;
}

const TAG_HUES = 8;

/** A hue in degrees, one of eight evenly spaced, so the same tag always gets the same color. */
export function tagHue(tag: string): number {
  let hash = 0;
  for (const character of tag) hash = (hash * 31 + (character.codePointAt(0) ?? 0)) >>> 0;
  return (hash % TAG_HUES) * (360 / TAG_HUES) + 12;
}
